import axios from "../../privateApi";

export const markSbcSolved = (sbcId: number, setId: number, solved: boolean) =>
  axios.post("/mark-sbc-solved", { sbcId, setId, solved });
